<template>

<Teleport to="body">
  <div class="fixed inset-0 z-50 flex justify-center bg-black/60">
    <div class="m-5 w-full md:w-8/12 lg:w-7/12" @click.self="closeDialog()" >

      <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
        
        <div class="flex flex-col w-full text-black">
        
          <BlockUI :visible="blocked">

            <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
            </div>

            <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
              <div>
                <font-awesome-icon :icon="['far', 'fa-building']" class="w-6 h-6 text-white" />
              </div>
              <div class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis"> 
                {{ empresa.nombreFantasia }}
              </div>
            </div>


            <div class="bg-white text-gray-600 space-y-3 text-xs sm:text-sm lg:text-lg p-3">

              <!-- LOGO Y DESCRIPCIÓN -->
              <div class="rounded-lg flex flex-col items-center text-center p-1">
                <img v-if="empresa.previewLogo" :src="empresa.previewLogo" class="w-32 h-32 object-cover rounded-full border-2 border-white shadow-md" />
                <div v-else
                  class="w-32 h-32 object-cover rounded-full border-2 border-white shadow-md flex items-center justify-center font-semibold text-3xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]">
                  <span class="leading-none text-gray-500 mb-1 text-xl">
                    {{ iniciales(empresa.nombreFantasia, '') }}
                  </span>
                </div>
                <div v-html="empresa.breveDescripcion" class="text-justify md:text-center"></div>
              </div>
              <!-- FIN LOGO Y DESCRIPCIÓN -->

              <!-- STAND -->
              <div class="border border-gray-200 shadow-md rounded-lg p-4 gap-3" v-if="empresa.stand || empresa.pabellon">
                <div class="text-lg text-center uppercase"><font-awesome-icon :icon="['fas', 'store']" /> PABELLÓN {{ empresa.pabellon }} - STAND {{empresa.stand}}</div> 
              </div>
              <!-- FIN STAND -->

              <div class="flex flex-col lg:flex-row lg:gap-3">

                <!-- DOMICILIO -->
                <div class="flex text-left flex-col lg:flex-row border border-gray-200 shadow-md rounded-lg p-4 lg:gap-3 lg:w-1/2" v-if="empresa.domicilio || empresa.localidad || empresa.provincia">
                  <div class="w-full flex flex-row space-x-3">
                    <div>
                      <font-awesome-icon :icon="['fas', 'location-dot']" />
                    </div>
                    <div class="w-full flex flex-col">
                      <span>{{ empresa.domicilio }}</span>
                      <span>{{ empresa.localidad }}</span>
                      <span>{{ empresa.provincia }}</span>
                      <span>CP : {{ empresa.codigoPostal }}</span>
                      <span>{{ empresa.pais.descripcion }}</span>
                      <a :href="'tel:// ' + empresa.mailComercial">
                        <font-awesome-icon :icon="['fas', 'phone']" class="mr-2" />{{ empresa.telefono }}
                      </a>
                      <a :href="googleMapsUrl"  target="_blank" class="text-blue-500 underline" v-if="googleMapsUrl">
                        ¿Cómo llegar?
                      </a>
                    </div>
                  </div>
                </div>
                <!-- FIN DOMICILIO -->
                  
                <!-- CONTACTO -->
                <div class="flex text-left flex-col border border-gray-200 shadow-lg rounded-lg p-4 md:pl-6 gap-1 lg:w-1/2">
                  <div class="w-full">
                    <a :href="'mailto: ' + empresa.mailComercial">
                      <font-awesome-icon :icon="['far', 'envelope']" class="mr-1" />{{ empresa.mailComercial }}
                    </a>
                  </div>
                  <div  v-for="empresaRedSocial in empresa.empresaRedesSociales?.filter(r => r.link)" v-bind:key="empresaRedSocial.id" :empresaRedSocial="empresaRedSocial">
                    <div class="w-full">
                      <font-awesome-icon :icon="empresaRedSocial.redSocial.icono.split(' ')" class="mr-1" />
                      <a href="{{empresaRedSocial.link}}">{{empresaRedSocial.link}}</a>
                    </div>
                  </div>
                </div>
                <!-- FIN CONTACTO -->    
              </div>


              <div class="w-full grid grid-cols-1  gap-4" v-if="empresa.productos">
                <div  v-for="producto in empresa.productos" v-bind:key="producto.id" :producto="producto">
                  <div class="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5  border border-gray-200 shadow-lg rounded-lg p-4 gap-3 h-full">

                    <div class="lg:col-span-1 w-full aspect-square overflow-hidden rounded-lg">
                      <img :src="producto.previewFotoFile" class="w-full h-full object-cover object-center"/>            
                    </div>
                    <div class="lg:col-span-3 xl:col-span-4 flex flex-col text-justify ">
                      <div class="text-2xl">{{producto.descripcion}}</div>
                      <div class="text-gray-600 mt-1">{{producto.detalles}}</div>                      
                    </div>

                  </div>
                </div>
              </div>

              <!-- TAGS -->
              <div v-if="empresa.empresaTags" class="flex text-left flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1">
                <div v-for="[tagId, { tag, tagOpciones }] in tags" :key="tagId">
                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                    <div class="w-full px-2">
                      <label class="block mb-2 text-xs">{{ tag.descripcion }}</label>
                      <div class="flex flex-wrap gap-2 text-sm">
                        <span v-for="tagOpcion in tagOpciones" :key="tagOpcion.id" class="px-3 py-1 bg-gray-200 rounded-lg">
                          {{ tagOpcion.descripcion }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>      
              </div>
              <!-- FIN TAGS -->
              
              <a @click="closeDialog()" class="w-full block cursor-pointer text-lg font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-lg transform transition-transform duration-200 hover:hover:scale-[100.5%]">
                <font-awesome-icon :icon="['fas', 'xmark']" /> {{ $t('boton.cerrar') }}
              </a>

            </div>
          </BlockUI>

        </div>
      </div>

    </div>
  </div>
</Teleport>    
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import { Empresa, Tag, TagOpcion } from 'qreventos-suite/src/services/suite.interfaces';

export default defineComponent({  
  components: {
    BlockUI, ProgressSpinner
  },
  props: {
    empresa: {
      type: {} as PropType<Empresa>,
      required: true
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  methods: {
    closeDialog() {
      if(this.closeFunction) {
        this.closeFunction();
      }
    },
    iniciales(nombre: string, apellido: string): string {
      const n = nombre?.charAt(0) || '';
      const a = apellido?.charAt(0) || '';
      return (n + a).toUpperCase();
    },
  },
  computed: {
    googleMapsUrl() {
      let direccion:string = this.empresa.domicilio? this.empresa.domicilio: '';
      direccion += this.empresa.localidad? ', ' + this.empresa.localidad : '';
      direccion += this.empresa.provincia? ', ' + this.empresa.provincia: '';
      direccion += this.empresa.pais && this.empresa.pais.descripcion? ', ' + this.empresa.pais.descripcion : '';
      return direccion ? `https://www.google.com/maps/search/?q=${encodeURIComponent(direccion)}`: '';
    }
  },  
  data() {
    return {
      blocked: false,
      tags: {} as Map<number, { tag: Tag; tagOpciones: TagOpcion[] }>
    };
  },  
  mounted() {
    document.body.style.overflow = "hidden";

    this.tags = this.empresa.empresaTags?.reduce((acc, empresaTag) => {
      const tagId = empresaTag.tag.id;

      if (!acc.has(tagId)) {
        acc.set(tagId, { tag: empresaTag.tag, tagOpciones: [] });
      }

      acc.get(tagId)?.tagOpciones.push(empresaTag.tagOpcion);
        return acc;
      }, new Map<number, { tag: Tag; tagOpciones: TagOpcion[] }>());
  },
  unmounted() {
    document.body.style.overflow = "";
  }  
});
</script>
